import { CloseButton } from "@/components/CloseButton/CloseButton";
import { SearchInput } from "@/components/SearchInput/SearchInput";
import { SpinLoader } from "@/components/SpinLoader/SpinLoader";
import { UIButton } from "@/components/UIButton/UIButton";
import { toggleModal } from "@/core/reatom/state/modal/modal";
import {
  currentSubCategories,
  isLoadingAtom,
} from "@/core/reatom/state/profGroups/";
import {
  paramsAtom,
  selectedCategoriesAtom,
  selectedProfessionsAtom,
  toggleProfessionsIdAction,
} from "@/core/reatom/state/search/";
import { useAction, useAtom } from "@reatom/npm-react";
import { Icon24CheckCircleOn } from "@vkontakte/icons";
import clsx from "clsx";
import { useState } from "react";
import s from "./style.module.scss";
import { professionIdsAtom } from "@/core/reatom/state/search/search";

interface CategoriesProps {
  closeModal: () => void;
}

export const SubCategories = ({ closeModal }: CategoriesProps) => {
  const handleToggleModal = useAction(toggleModal);

  const [search, setSearch] = useState("");

  const [profGroupDetail] = useAtom(currentSubCategories);
  const [selectedProfessions] = useAtom(selectedProfessionsAtom);
  const [selectedCategories] = useAtom(selectedCategoriesAtom);

  const [isLoading] = useAtom(isLoadingAtom);
  const [params] = useAtom(paramsAtom);
  const [selectedProfessionsIds] = useAtom(professionIdsAtom);
  const toggleProfessions = useAction(toggleProfessionsIdAction);

  const searchedSubCategories = profGroupDetail?.filter((item) =>
    item.name.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className={s.wrapper}>
      <CloseButton onClose={closeModal} />
      <p className={s.title}>Подкатегории</p>
      <div className={s.input}>
        <SearchInput
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          reset={() => setSearch("")}
        />
      </div>
      <div className={s.categories}>
        {isLoading ? (
          <SpinLoader />
        ) : searchedSubCategories?.length ? (
          searchedSubCategories.map((item) => (
            <CurrentCategories
              key={item.id}
              name={item.name}
              id={item.id}
              onClick={() => toggleProfessions(item.id)}
              selected={
                !!selectedProfessionsIds?.length &&
                selectedProfessionsIds.includes(item.id)
              }
            />
          ))
        ) : (
          <div className={s.empty_list}>
            <span>
              Для просмотра списка <br /> выберите категорию
            </span>
          </div>
        )}
      </div>

      {!selectedCategories ? (
        <UIButton
          onClick={() => handleToggleModal("categories")}
          fontType={"primary-2"}
          className={s.submit}
        >
          Выбрать категорию
        </UIButton>
      ) : (
        <UIButton
          onClick={() => {
            closeModal();
          }}
          fontType={"primary-2"}
          className={s.submit}
          // disabled={!selectedProfessions?.length}
        >
          Смотреть результат
        </UIButton>
      )}
    </div>
  );
};

interface CurrentCategoriesProps {
  name: string;
  id: number;
  onClick: () => void;
  selected: boolean;
}

const CurrentCategories = (props: CurrentCategoriesProps) => {
  const { name, onClick, selected } = props;
  return (
    <div className={s.category} onClick={onClick}>
      <p className={clsx(s.name, selected && s.selected)}>{name}</p>
      {selected && (
        <div className={s.icon}>
          <Icon24CheckCircleOn />
        </div>
      )}
    </div>
  );
};
